/* */ 
var baseProperty = require('./baseProperty');
var getLength = baseProperty('length');
module.exports = getLength;
